module.exports = __webpack_public_path__ + "static/media/signin-illustration-v2.e1a10f9a.svg";